import { Grid, Box, Typography, Button, Container, Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useEffect, useContext, useState } from 'react';
import LogicContext from '../../Context/LogicContext';
import { createModal } from 'react-modal-promise';
import GeneralModal from '../../helpers/GeneralModal';
import SelectSelect from './StatusSelect';
import { FileUploader } from 'react-drag-drop-files';
import { settingsService } from '../../services/settingsService';
import moment from 'moment';
import { GetProductCatFeatureAtom, SetProductFeatureEditAtom, GetProductFeatureEditAtom } from '../../store/productCategoryFeatureAtom';
import ProductFeatureSelect from './ProductFeatureSelect';
import SpecialImgSelect from './SpecialImgSelect';
import VisibleToggle from './VisibleToggle';

const BASE_WIDTH_WEB = 320;
const BASE_HEIGHT_WEB = 320;

function AddProductFeature() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const myPromiseModal = createModal(GeneralModal);
  const dataAtomStore = GetProductCatFeatureAtom();
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const logicContext = useContext(LogicContext);

  const [webUrl, setWebUrl] = useState('');
  const setEditData = SetProductFeatureEditAtom();
  const getEditData = GetProductFeatureEditAtom();
  const [webFile, setWebFile] = useState(null);
  const [imageWebSource, setWebImageSource] = useState(null);
  const fileTypes = ['JPG', 'PNG', 'GIF', 'JPEG'];
  const [textColor, setTextColor] = useState('#fff');
  const [backgroundColor, setBackgroundColor] = useState('#fff');
  const [tempWebWidth, setWebTempWidth] = useState(0);
  const [tempWebHeight, setWebTempHeight] = useState(0);
  const isEditMode = getEditData?.Action_URL_Id >= 0;

  useEffect(() => {
    let isMounted = true;

    if (getEditData?.Action_URL_Id >= 0) {
      if (isMounted) {
        setValue('Action_URL_Id', getEditData.Action_URL_Id);
        setValue('product_id', getEditData.Product_Id);
        setValue('name', getEditData.Product_Name);
        setValue('image_url', getEditData.Image_URL);
        setValue('Image_Id', getEditData?.Special_Image_Id);

        setValue('background_color', getEditData.Background_Color);
        setValue('Text_Color', getEditData.Text_Color);
        setValue('display_order', getEditData.Display_Order);
        setValue('status_id', getEditData.Status_Id);
        setValue('description', getEditData.Product_Description);

        setBackgroundColor(getEditData.Background_Color);
        setTextColor(getEditData.Text_Color);
        setWebUrl(getEditData?.Action_URL_Web);
        setWebImageSource(getEditData.Image_URL);
      }
    }

    return () => {
      isMounted = false;
      setEditData({});
    };
  }, [getEditData, setValue, setEditData]);

  const onSubmit = async () => {
    const formValues = getValues();
    if (!imageWebSource) {
      return logicContext.showToast('Please upload Web image', 'error');
    }

    const option = isEditMode ? 2 : 1;

    await myPromiseModal({
      title: `${isEditMode ? 'Update' : 'Save'} record!`,
      body: `Please confirm your action.`,
      showInput: false,
      placeHolder: '',
    }).then(res => {
      if (res.decision === true) {
        const formData = new FormData();
        formData.append('file', webFile);
        var formObject = JSON.stringify({ ...formValues, option });
        formData.append('formObject', formObject);
        settingsService.submitNewProductFeature(formData).then(res => {
          if (res?.data?.length && res?.data[0]?.message_id === 1) {
            logicContext.showToast(res?.data[0].message_text, 'success');
            if (isEditMode) {
              navigate(-1);
            } else {
              reset();
              navigate(-1);
            }
          }
        });
      }
    });
  };

  function formError(error) {
    logicContext.showToast('Form error', 'error');
  }

  const onStatusSelect = eveData => {
    setValue('status_id', eveData.value);
  };

  const onWebImageLoad = event => {
    const imageWidth = event?.target?.naturalWidth;
    const imageHeight = event?.target?.naturalHeight;
    setWebTempHeight(imageHeight);
    setWebTempWidth(imageWidth);
    if (imageHeight !== BASE_HEIGHT_WEB || imageWidth !== BASE_WIDTH_WEB) {
      logicContext.showToast(
        `Invalid image dimensions! Required: ${BASE_WIDTH_WEB}x${BASE_HEIGHT_WEB}px, Got: ${imageWidth}x${imageHeight}px`,
        'error'
      );
      clearWebImage();
    }
  };

  const handleWebImageChange = webFile => {
    setWebFile(webFile);
    if (webFile) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setWebImageSource(reader.result);
      });
      reader.readAsDataURL(webFile);
    }
  };

  const clearWebImage = () => {
    setWebFile(null);
    setWebImageSource(null);
    const uploader = document.getElementById('uploader');
    if (uploader) {
      uploader.value = '';
    }
  };

  const onFeatureSelect = data => {
    setValue('Action_URL_Id', data?.Action_URL_Id);
    setWebUrl(data?.Action_URL_Web);
  };

  const onSpecialImageSelect = data => {
    setValue('Image_Id', data?.Image_Id);
  };

  const onBackgroundColorChange = event => {
    const selectedColor = event.target.value;
    setValue('background_color', selectedColor);
    setBackgroundColor(selectedColor);
  };

  const onTextColorChange = event => {
    const selectedColor = event.target.value;
    setValue('Text_Color', selectedColor);
    setTextColor(selectedColor);
  };

  const onShowOnWeb = val => {
    setValue('Show_On_Web_Menu_Id', val);
  };

  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4, mt: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
          {isEditMode ? 'Edit' : 'Add New'} Product Feature
        </Typography>

        <form onSubmit={handleSubmit(onSubmit, formError)} className="space-y-6">
          <Grid container spacing={4}>
            {/* Left Column: Text Fields */}
            <Grid item xs={12} md={6}>
              <div className="space-y-4">
                {/* Feature Name */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Feature Name <span className="text-red-500">*</span>
                  </Typography>
                  <input
                    type="text"
                    placeholder="Enter product feature name"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 h-10 px-3"
                    {...register('name', { required: 'Name is required' })}
                  />
                  {errors.name && (
                    <Typography variant="caption" color="error" display="block" mt={1}>
                      {errors.name.message}
                    </Typography>
                  )}
                </div>

                {/* Description */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Description <span className="text-red-500">*</span>
                  </Typography>
                  <textarea
                    placeholder="Enter description"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-2 resize-none"
                    rows={4}
                    {...register('description', { required: 'Description is required' })}
                  />
                  {errors.description && (
                    <Typography variant="caption" color="error" display="block" mt={1}>
                      {errors.description.message}
                    </Typography>
                  )}
                </div>

                {/* Product Action */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Product Action <span className="text-red-500">*</span>
                  </Typography>
                  <div className="flex items-center gap-2 mb-3">
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => window.open(`/${currModuleId}/${currModuleName}/product-feature-action-url/add-new`, '_blank')}
                      sx={{ textTransform: 'none' }}
                    >
                      New URL
                    </Button>
                    {webUrl && (
                      <Typography variant="body2" color="textSecondary">
                        Web URL: <span className="text-blue-600">{webUrl}</span>
                      </Typography>
                    )}
                  </div>
                  <ProductFeatureSelect
                    onFeatureSelect={onFeatureSelect}
                    defaultVal={getEditData?.Product_Name}
                    list={dataAtomStore.action_url_info}
                    {...register('Action_URL_Id', { required: 'Product action is required' })}
                  />
                  {errors.Action_URL_Id && (
                    <Typography variant="caption" color="error" display="block" mt={1}>
                      {errors.Action_URL_Id.message}
                    </Typography>
                  )}
                </div>

                {/* Special Image */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Special Image
                  </Typography>
                  <SpecialImgSelect
                    onFeatureSelect={onSpecialImageSelect}
                    defaultVal={getEditData?.Special_Image_Name}
                    list={dataAtomStore.special_image_info}
                    {...register('Image_Id')}
                  />
                </div>
              </div>
            </Grid>

            {/* Right Column: Image, Colors, etc. */}
            <Grid item xs={12} md={6}>
              <div className="space-y-4">
                {/* Web Image Uploader & Preview */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Upload Web Image <span className="text-red-500">*</span> (320x320px)
                  </Typography>
                  <div className="flex flex-col items-center space-y-4 p-4 border border-gray-200 rounded-lg bg-white shadow-sm">
                    {/* Upload Area */}
                    <div className="w-full max-w-md">
                      <FileUploader
                        className="uploader border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 transition-colors cursor-pointer bg-gray-50"
                        id="uploader"
                        minSize={0.1}
                        maxSize={3}
                        handleChange={handleWebImageChange}
                        name="file"
                        types={fileTypes}
                        multiple={false}
                      >
                        <div className="flex flex-col items-center space-y-2">
                          <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                          <p className="text-sm font-medium text-gray-700">Drop your image here or click to browse</p>
                          <p className="text-xs text-gray-500">Supports JPG, PNG (max 3MB, 320x320px required)</p>
                        </div>
                      </FileUploader>
                    </div>

                    {/* Preview */}
                    {imageWebSource ? (
                      <div className="flex justify-center">
                        <div className="relative">
                          <img
                            className="rounded-lg border-4 border-gray-200 shadow-lg object-cover"
                            onLoad={onWebImageLoad}
                            src={imageWebSource}
                            alt="Web Preview"
                            style={{ width: '200px', height: '200px' }}
                          />
                          <button
                            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600 transition-colors"
                            onClick={clearWebImage}
                            type="button"
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="w-48 h-48 rounded-lg bg-gray-100 flex items-center justify-center border-2 border-dashed border-gray-300">
                        <p className="text-gray-500 text-sm">No image selected</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Background and Text Color */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Colors
                  </Typography>
                  <div className="flex items-center gap-6">
                    <div className="flex flex-col">
                      <label className="text-sm font-medium text-gray-700 mb-1">Background Color</label>
                      <input
                        type="color"
                        value={backgroundColor}
                        onChange={onBackgroundColorChange}
                        className="w-12 h-6 p-0 border border-gray-300 rounded"
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-sm font-medium text-gray-700 mb-1">Text Color</label>
                      <input
                        type="color"
                        value={textColor}
                        onChange={onTextColorChange}
                        className="w-12 h-6 p-0 border border-gray-300 rounded"
                      />
                    </div>
                  </div>
                </div>

                {/* Visibility Toggle */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Show on Web
                  </Typography>
                  <VisibleToggle visible={getEditData?.Show_On_Web_Menu_Id} onVisibleChange={onShowOnWeb} />
                </div>

                {/* Display Order */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Display Order <span className="text-red-500">*</span>
                  </Typography>
                  <input
                    type="number"
                    placeholder="Enter display order"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 h-10 px-3"
                    {...register('display_order', { required: 'Display order is required' })}
                  />
                  {errors.display_order && (
                    <Typography variant="caption" color="error" display="block" mt={1}>
                      {errors.display_order.message}
                    </Typography>
                  )}
                </div>

                {/* Status */}
                <div>
                  <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Status
                  </Typography>
                  <SelectSelect defaultVal={getEditData?.Status_Id} onStatusSelect={onStatusSelect} />
                </div>
              </div>
            </Grid>
          </Grid>

          {/* Submit Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
            <Button type="submit" variant="contained" size="large" sx={{ px: 4, py: 1.5 }}>
              Submit
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
}

export default AddProductFeature;
